import type { EditAssetWorkflowOptions } from '../../types';

export const editCarrierRateSetWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'editCarrierRateSetWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'carrierRateSet',
  workflowIndex: 2,
  workflowName: 'Edit',
  overrideSave: 'editCarrierRateSet',
  workflowActionIcon: 'EditOutlined',
  hideIfDisabled: true,
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      archived: { type: 'boolean', const: false },
      active: { type: 'boolean', const: true },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'carrierSelect',
      workflowStepNavigationName: 'Carrier',
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
        suffix: ' Account',
      },
      workflowComponent: {
        singleSelect: true,
        hideServiceMethods: true,
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this rate set apply to?',
        description: 'We need to know which carrier you are using to guide you through setting up your account',
        help: `If you don't see your carrier here please contact a shipium admin `,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierId',
      },
    },
    {
      workflowStepKey: 'carrierRates',
      workflowStepNavigationName: 'Rate Set Entries',
      workflowComponent: {
        workflowComponentType: 'assetSetSelect',
        prompt: 'Which carrier rates should be included in this rate set?',
        description: '',
        help: '',
        assetType: 'carrierRate',
        assetIdProperty: 'carrierRateId',
        assetFilterProperties: {
          workflowStepKeyToMatch: 'carrierSelect',
          assetPropertyToMatch: 'carrier',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierRateIds',
      },
    },
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Rate Set ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this rate set',
        description: 'This is optional but will allow you to more easily reference this rate set in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Rate Set Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'What will you call this Carrier Rate Set?',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Rate Set Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 2,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this carrier rate set belong belong to a specific tenant?',
        description: '',
        help: '',
        optional: true,
      },
      calculatedComponentProps: {
        assetId: {
          type: 'asset',
          property: 'carrierRateSetId',
        },
      },
      optional: true,
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Edit Carrier Rate Set Summary',
        description: 'The Carrier Rate Set will be updated.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
